import { render } from "./ModelSummaryCard.vue?vue&type=template&id=650144bf&scoped=true&ts=true"
import script from "./ModelSummaryCard.vue?vue&type=script&lang=ts"
export * from "./ModelSummaryCard.vue?vue&type=script&lang=ts"

import "./ModelSummaryCard.vue?vue&type=style&index=0&id=650144bf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650144bf"]])

export default __exports__